import React from 'react'

interface IntegrationsProps {
  isSelected?: boolean
}

export const IntegrationsIcon: React.FC<IntegrationsProps> = ({ isSelected = false }) => {
  const stroke = isSelected ? '#FF4A8E' : '#62718D'
  const className = isSelected ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'

  return (
    <svg width="20" height="20" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.23189 4L18.5006 14.2687L15.9331 16.8362C15.2638 17.5323 14.4623 18.088 13.5757 18.4706C12.689 18.8533 11.7349 19.0552 10.7693 19.0647C9.80359 19.0742 8.84574 18.891 7.95173 18.5258C7.05773 18.1606 6.24554 17.6208 5.56268 16.9379C4.87982 16.2551 4.34 15.4429 3.97482 14.5489C3.60964 13.6549 3.42642 12.697 3.4359 11.7314C3.44537 10.7657 3.64734 9.81161 4.02998 8.92494C4.41263 8.03828 4.96827 7.23683 5.6644 6.56749L8.23189 4Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M1 21.5L5.37499 17.125"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M14.75 1.5L10.375 5.87499"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
      <path
        d="M21 7.75L16.625 12.125"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
    </svg>
  )
}

export default IntegrationsIcon
